import { createAction } from 'redux-actions';

export const fetchAppOperations = createAction('FETCH_APP_OPERATIONS');
export const fetchAppOperationsSuccess = createAction('FETCH_APP_OPERATIONS_SUCCESS');
export const fetchAppOperationsFailure = createAction('FETCH_APP_OPERATIONS_FAILURE');
